"use client";

const dots = [0, 1, 2];
export const ThinkingAnimation = () => {
   return (
      <>
         <div className="thinking-animation flex items-center space-x-1">
            {dots.map((index) => (
               <div key={index} className="dot"></div>
            ))}
         </div>
         {stylesheet()}
      </>
   );
};
const styles = `
    .thinking-animation {
        padding-top:0.5rem;
        padding-left:0.5rem;
        padding-right:0.5rem;
        padding-bottom: 0rem;
    }
    .dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #3b82f6;
        animation: thinking 1.4s infinite ease-in-out;
    }
    .dot:nth-child(2) {
        animation-delay: 0.2s;
    }
    .dot:nth-child(3) {
        animation-delay: 0.4s;
    }
    @keyframes thinking {
        0%, 100% {
            transform: scale(0.5) translate(0, 0);
            opacity: 0.2;
        }
        50% {
            transform: scale(1.5) translate(6px, -6px);
            opacity: 1;
        }
    }
    :global(.dark) .dot {
        background-color: #60a5fa;
    }
`;

const stylesheet = () => (
   <style jsx global>
      {styles}
   </style>
);
